import { flow } from 'lodash';
import { NAME } from './dialogs.constant';

import { selectPaymentState } from '../payment.selector';

const selectState = (state) => state[NAME];

export const selectDialogsState = flow(selectPaymentState, selectState);
